import type { Category } from '@/types/category';
import { productApi } from './product';

export const categoryApi = productApi.injectEndpoints({
  endpoints: (builder) => ({
    getCategories: builder.query<Category[], void>({
      query: () => '/api/categories',
      providesTags: ['category'],
    }),
  }),
});

export const { useGetCategoriesQuery } = categoryApi;
